module.exports = "/_next/static/images/avatar_4-1fdd9c13f8773bcf24bb60736f05ae7c.png";